/**
 * Adhoc booth legal disclaimer — must match backend ADHOC_DISCLAIMER_VERSION.
 * Bump version in both places when legal copy changes.
 */

export const ADHOC_DISCLAIMER_VERSION = '2026-06-1';

export const ADHOC_DISCLAIMER_TITLE = 'Before we begin, a few things to confirm';

export const ADHOC_DISCLAIMER_LEDE =
  'Please read this carefully — it explains what MyWellfie is, and just as importantly, what it isn\'t.';

export const ADHOC_DISCLAIMER_SECTIONS: { title: string; paragraphs: string[] }[] = [
  {
    title: 'What MyWellfie is',
    paragraphs: [
      'MyWellfie uses your device\'s camera to estimate wellness indicators from subtle visual signals in your face during a short, resting video. It\'s designed to help you track trends in your wellbeing over time.',
    ],
  },
  {
    title: 'What it isn\'t',
    paragraphs: [
      'MyWellfie is not a medical device, and your results are not a medical diagnosis. Your scan does not detect, diagnose, treat, cure, or prevent any disease or health condition.',
    ],
  },
  {
    title: 'Talk to a professional',
    paragraphs: [
      'Your results are not a substitute for advice, examination, or treatment from a qualified physician or other licensed healthcare provider. Always consult a doctor with any questions about a medical condition, and never disregard or delay professional medical advice because of something you read in a MyWellfie report.',
    ],
  },
  {
    title: 'In an emergency',
    paragraphs: [
      'If you believe you may be experiencing a medical emergency, call your local emergency number immediately. Do not rely on MyWellfie for urgent or emergency situations.',
    ],
  },
];

export const ADHOC_DISCLAIMER_CHECKBOX_LABEL =
  'I understand that MyWellfie is not a medical diagnosis and does not replace professional medical advice, and I wish to proceed.';
